import { useState, useMemo } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './faq.css';

const faqs = [
  {
    question: 'What is YUVANXT?',
    answer: 'YUVANXT is the name of our club membership drive. Derived from Yuva, meaning youth, and NXT, symbolizing the next generation and forward movement, it reflects our commitment to empowering young minds and shaping the future.',
    category: 'Membership'
  },
  {
    question: 'What kinds of initiatives does YUVA do?',
    answer: 'YUVA undertakes initiatives focused on community welfare, social awareness, and compassionate outreach, providing support and assistance to individuals and groups in need.',
    category: 'Initiatives'
  },
  {
    question: 'How long does the YUVA membership remain valid?',
    answer: 'The YUVA membership remains valid until October month of each academic year.',
    category: 'Membership'
  },
  {
    question: 'Can I give suggestions even if I am not a core member?',
    answer: 'Yes. All members are welcome to share ideas, participate in events, and actively contribute to the club activities.',
    category: 'Membership'
  },
  {
    question: 'How will updates and announcements be shared?',
    answer: 'Members are added to the official club group where all updates, announcements, and event details are shared regularly.',
    category: 'Updates'
  },
  {
    question: 'Will YUVA organize external events?',
    answer: 'Yes. YUVA organizes and participates in external events, providing members with broader exposure beyond campus activities.',
    category: 'Events'
  },
  {
    question: 'What is a Networking Session?',
    answer: 'A networking session is an interactive event where members engage with peers and professionals to exchange ideas and build meaningful connections.',
    category: 'Events'
  },
  {
    question: 'Does YUVA conduct monthly idea exchange sessions?',
    answer: 'Yes. Monthly idea exchange and networking sessions are conducted to encourage collaboration and innovation.',
    category: 'Events'
  },
];

const FAQs = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const filteredFaqs = useMemo(() => {
    if (!searchQuery.trim()) return faqs;

    const query = searchQuery.toLowerCase();
    return faqs.filter(
      (faq) =>
        faq.question.toLowerCase().includes(query) ||
        faq.answer.toLowerCase().includes(query) ||
        faq.category.toLowerCase().includes(query)
    );
  }, [searchQuery]);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      <Navbar />

      <div className="faq-premium-page">
        {/* ANIMATED BACKGROUND */}
        <div className="faq-background">
          <div className="faq-glow glow-1" />
          <div className="faq-glow glow-2" />
          <div className="faq-glow glow-3" />
        </div>

        {/* PREMIUM HERO SECTION */}
        <section className="faq-premium-hero">
          <div className="faq-hero-content">
            <h1 className="faq-hero-title">
              <span className="faq-hero-line">Answers,</span>
              <span className="faq-hero-line gradient-text">Designed for Clarity.</span>
            </h1>
            <p className="faq-hero-subtitle">
              Explore guidance, membership insights, event information, and innovation ecosystem support.
            </p>
            <div className="faq-accent-line" />
          </div>
        </section>

        {/* PREMIUM SEARCH */}
        <div className="faq-search-container">
          <div className="faq-search-wrapper">
            <svg className="faq-search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <circle cx="11" cy="11" r="8" />
              <path d="m21 21-4.35-4.35" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <input
              type="text"
              className="faq-search-input"
              placeholder="Search YUVA knowledge..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            {searchQuery && (
              <button
                className="faq-search-clear"
                onClick={() => setSearchQuery('')}
              >
                ✕
              </button>
            )}
          </div>
        </div>

        {/* FAQ CONTAINER */}
        <div className="faq-premium-container">
          {filteredFaqs.length === 0 ? (
            <div className="faq-no-results">
              <p>No results found for "{searchQuery}"</p>
              <button onClick={() => setSearchQuery('')} className="faq-reset-btn">
                Clear search
              </button>
            </div>
          ) : (
            <div className="faq-list">
              {filteredFaqs.map((faq, index) => (
                <div
                  key={index}
                  className="faq-premium-item"
                >
                  <button
                    className={`faq-premium-question ${activeIndex === index ? 'active' : ''}`}
                    onClick={() => toggleFAQ(index)}
                  >
                    <div className="faq-question-content">
                      <span className="faq-category">{faq.category}</span>
                      <h3 className="faq-question-text">{faq.question}</h3>
                    </div>
                    <div className={`faq-expand-icon ${activeIndex === index ? 'rotate' : ''}`}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="12" y1="5" x2="12" y2="19" />
                        <line x1="5" y1="12" x2="19" y2="12" />
                      </svg>
                    </div>
                  </button>

                  {activeIndex === index && (
                    <div className="faq-premium-answer">
                      <p>{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default FAQs;
